<div *ngIf="customFields && customFields.length > 0">
    <ng-container *ngFor="let field of customFields">
        <ng-container [ngSwitch]="field.formControl.name">
            <ng-container *ngSwitchCase="'InputBox'">
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <label class="p-mb-2">
                        {{ field.name }}
                        <span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <input pInputText type="text" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" /> 
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DropDownList'">
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{ field.name }}<span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <p-dropdown [options]="field.pickListValues" [id]="'cf_info' + i" [name]="'cf_info' + i" [placeholder]="
                            'Select ' + field.name
                        " optionLabel="name" dataKey="name" [(ngModel)]="field.value"  appendTo="body" [ngModelOptions]="{
                            standalone: true
                        }"></p-dropdown>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'MultipleDropDownList'">
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{ field.name }}<span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <p-multiSelect [options]="field.pickListValues" [id]="'cf_info' + i" [name]="'cf_info' + i" [placeholder]="
                            'Select ' + field.name
                        " optionLabel="name" dataKey="name" [(ngModel)]="field.value"  appendTo="body" [ngModelOptions]="{
                            standalone: true
                        }"> </p-multiSelect>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'CheckBox'">
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{ field.name }}<span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <ng-container *ngFor="
                            let opt of field.pickListValues;
                            let j = index
                        ">
                        <p-checkbox [name]="'cf_chkbx' + i" [value]="opt.name" [(ngModel)]="field.value" [ngModelOptions]="{
                                standalone: true
                            }"> </p-checkbox> {{ opt.name }} </ng-container>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'FileUpload'">
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{ field.name }}<span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <p-fileUpload name="myfile[]" customUpload="true" (onSelect)="
                            onCustomUpload(
                                $event.files,
                                field
                            )
                        " multiple="multiple" accept="image/*" maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <ul *ngIf="
                                    field
                                        .customUploadedFiles
                                        .length
                                ">
                                <li *ngFor="
                                        let file of field.customUploadedFiles
                                    "> {{ file.name }} - {{ file.size }} bytes </li>
                            </ul>
                        </ng-template>
                    </p-fileUpload>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Picture'">
                <div class="p-col-12 p-lg-6 p-mt-2 p-mb-2">
                    <label class="p-mb-2">{{ field.name }}<span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <p-fileUpload name="myfile[]" customUpload="true" (onSelect)="onCustomUpload($event.files,field)" multiple="multiple" accept="image/*" maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <ul *ngIf="field.customUploadedFiles.length">
                                <li *ngFor="let file of field.customUploadedFiles"> 
                                    <img [src]="file.content" height="20" width="30" alt="pic" /> 
                                    {{ file.name }} 
                                </li>
                            </ul>
                        </ng-template>
                    </p-fileUpload>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'RadioButton'">
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{ field.name }}<span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <ng-container *ngFor="let opt of field.pickListValues; let j = index">
                        <p-radioButton [name]="'cf_rdo' + i" [value]="opt.name" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"> 
                        </p-radioButton>&nbsp;{{ opt.name }} 
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Rating'">
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{ field.name }}<span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <p-rating [cancel]="false" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"></p-rating>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ToggleButton'">
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <p-toggleButton class="p-mb-2" onLabel="{{ field.name }}" offLabel="{{ field.name }}" [onIcon]="'pi pi-check'" [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"> </p-toggleButton>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <label class="p-mb-2" style="width: 60%">{{ field.name }}<span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <p-calendar [(ngModel)]="field.value" [ngModelOptions]="{ standalone: true }"></p-calendar>
                </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                    <label class="p-mb-2">
                        {{ field.name }}
                        <span style="color: red" *ngIf="checkRequired(field.name)">*</span>
                    </label>
                    <input pInputText type="text" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" /> 
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</div>